function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var ChateauxTemplate = require('./chateaux.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ChateauxOverlay = /*#__PURE__*/function () {
  function ChateauxOverlay(app, mod) {
    _classCallCheck(this, ChateauxOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
    this.selected = [];
    this.bonus = 0;
    this.roll = 0;
  }
  return _createClass(ChateauxOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'france';
      this.visible = true;
      this.overlay.show(ChateauxTemplate());

      // bonuses
      var bonus = 0;
      var p = this.mod.returnPlayerOfFaction(faction);
      if (this.mod.isSpaceControlled('milan', 'france')) {
        bonus += 2;
        document.querySelectorAll('.modifier1').forEach(function (el) {
          el.style.borderBottom = '2px dashed yellow';
          el.style.color = 'white';
        });
      }
      if (this.mod.isSpaceControlled('florence', 'france')) {
        bonus += 1;
        document.querySelectorAll('.modifier2').forEach(function (el) {
          el.style.borderBottom = '2px dashed yellow';
          el.style.color = 'white';
        });
      }
      var italian_keys = 0;
      var occupied_french_space = 0;
      var controlled_french_space = 0;
      for (var x in this.mod.game.spaces) {
        var s = this.mod.game.spaces[x];
        if (s.language == 'italian' && s.type == 'key') {
          if (this.mod.isSpaceControlled(s.key, 'france')) {
            italian_keys++;
          }
        }
        if (s.home == 'france') {
          if (!this.mod.isSpaceControlled(s.key, 'france')) {
            controlled_french_space++;
          }
          if (this.mod.doesSpaceHaveNonFactionUnits(s.key, 'france')) {
            occupied_french_space++;
          }
        }
      }
      if (italian_keys >= 3) {
        bonus += 2;
        document.querySelectorAll('.modifier3').forEach(function (el) {
          el.style.borderBottom = '2px dashed yellow';
          el.style.color = 'white';
        });
      }
      if (controlled_french_space > 0) {
        bonus -= 1;
        document.querySelectorAll('.modifier5').forEach(function (el) {
          el.style.borderBottom = '2px dashed yellow';
          el.style.color = 'white';
        });
      }
      if (occupied_french_space > 0) {
        bonus -= 2;
        document.querySelectorAll('.modifier6').forEach(function (el) {
          el.style.borderBottom = '2px dashed yellow';
          el.style.color = 'white';
        });
      }
      this.bonus = bonus;
      this.roll = this.mod.rollDice(6);
      if (this.bonus != 0) {
        this.mod.updateLog('Chateaux Roll: ' + this.roll + ' [' + this.bonus + ' bonus]');
      } else {
        this.mod.updateLog('Chateaux Roll: ' + this.roll);
      }
      var modified_roll = this.roll + this.bonus;
      document.querySelector('.chateaux-overlay .help').innerHTML = "".concat(this.mod.returnFactionName(faction), " rolls ").concat(this.roll, " (modified: ").concat(modified_roll, ")");

      // remove cards_left update from France
      for (var z = 0; z < this.mod.game.queue.length; z++) {
        var lqe = this.mod.game.queue[z];
        var lmv = lqe.split('\t');
        if (lmv[0] == 'cards_left' && lmv[1] == 'france') {
          this.mod.game.queue.splice(z, 1);
        }
      }
      if (modified_roll >= 8) {
        this.mod.updateLog('Patron of the Arts: +1 VP, draw 2 discard 1');
        document.querySelectorAll('.outcome1').forEach(function (el) {
          el.style.backgroundColor = 'yellow';
          el.style.color = 'black';
        });
        this.mod.game.state.french_chateaux_vp += 1;
        this.mod.game.queue.push('select_and_discard\t' + faction);
        this.mod.game.queue.push('hide_overlay\tchateaux');
        this.mod.game.queue.push('hand_to_fhand\t1\t' + p + '\t' + faction + '\t1');
        this.mod.game.state.cards_left['france'] += 2;
        this.mod.game.queue.push('DEAL\t1\t' + p + '\t' + 2);
        this.mod.game.queue.push("ACKNOWLEDGE\t".concat(this.mod.returnFactionName(faction), " rolls on the Chateaux Table"));
      }
      if (modified_roll >= 5 && modified_roll < 8) {
        this.mod.updateLog('Patron of the Arts: +1 VP, draw 1');
        document.querySelectorAll('.outcome2').forEach(function (el) {
          el.style.backgroundColor = 'yellow';
          el.style.color = 'black';
        });
        this.mod.game.state.french_chateaux_vp += 1;
        this.mod.game.queue.push('hide_overlay\tchateaux');
        this.mod.game.queue.push('hand_to_fhand\t1\t' + p + '\t' + faction + '\t1');
        this.mod.game.state.cards_left['france']++;
        this.mod.game.queue.push('DEAL\t1\t' + p + '\t' + 1);
        this.mod.game.queue.push("ACKNOWLEDGE\t".concat(this.mod.returnFactionName(faction), " rolls on the Chateaux Table"));
      }
      if (modified_roll >= 3 && modified_roll < 5) {
        this.mod.updateLog('Patron of the Arts: +1 VP, draw 1 discard 1');
        document.querySelectorAll('.outcome3').forEach(function (el) {
          el.style.backgroundColor = 'yellow';
          el.style.color = 'black';
        });
        this.mod.game.state.french_chateaux_vp += 1;
        this.mod.game.queue.push('select_and_discard\t' + faction);
        this.mod.game.queue.push('hide_overlay\tchateaux');
        this.mod.game.queue.push('hand_to_fhand\t1\t' + p + '\t' + faction + '\t1');
        this.mod.game.state.cards_left['france']++;
        this.mod.game.queue.push('DEAL\t1\t' + p + '\t' + 1);
        this.mod.game.queue.push("ACKNOWLEDGE\t".concat(this.mod.returnFactionName(faction), " rolls on the Chateaux Table"));
      }
      if (modified_roll <= 2) {
        this.mod.updateLog('Patron of the Arts: draw 2 discard 1');
        document.querySelectorAll('.outcome4').forEach(function (el) {
          el.style.backgroundColor = 'yellow';
          el.style.color = 'black';
        });
        this.mod.game.queue.push('select_and_discard\t' + faction);
        this.mod.game.queue.push('hide_overlay\tchateaux');
        this.mod.game.state.cards_left['france'] += 2;
        this.mod.game.queue.push('hand_to_fhand\t1\t' + p + '\t' + faction + '\t1');
        this.mod.game.queue.push('DEAL\t1\t' + p + '\t' + 2);
        this.mod.game.queue.push("ACKNOWLEDGE\t".concat(this.mod.returnFactionName(faction), " rolls on the Chateaux Table"));
      }
      this.pushHudUnderOverlay();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var his_self = this.mod;
      $('.chateaux-overlay').on('click', function () {
        _this.hide();
        if (document.querySelector('.option.acknowledge')) {
          document.querySelector('.option.acknowledge').click();
        }
      });
      $('.saito-overlay:has(> .chateaux-overlay) + .saito-overlay-backdrop').on('click', function () {
        _this.hide();
        if (document.querySelector('.option.acknowledge')) {
          document.querySelector('.option.acknowledge').click();
        }
      });
    }
  }]);
}();
module.exports = ChateauxOverlay;